<template lang='pug'>
  .bf-grid.component
    slot
</template>

<script>
  export default {
    name: 'bf-grid',
  }
</script>

<style scoped lang='stylus'>
  .bf-grid
    display grid
    grid-template-columns repeat( auto-fit, minmax( 320px, 1fr ) )
    grid-gap 2vh 2vw
    position relative
    &.loose
      grid-gap 3vh 3vw
    &.tight
      grid-gap 1vh 1vw


    &.small
      grid-template-columns repeat( auto-fit, minmax( 280px, 1fr ) )

    &.smaller
      grid-template-columns repeat( auto-fit, minmax( 240px, 1fr ) )

    &.smallest
      grid-template-columns repeat( auto-fit, minmax( 160px, 1fr ) )

    &.tiny
      grid-template-columns repeat( auto-fit, minmax( 128px, 1fr ) )

    &.thumbs
      grid-template-columns repeat( auto-fill, minmax( 160px, 1fr ) )
      grid-gap 3.6vw
      grid-auto-rows 160px
      @media( max-width: 480px )
        grid-template-columns repeat( auto-fill, minmax( 96px, 1fr ) )
        grid-auto-rows 96px

    &.card
      grid-template-columns repeat( auto-fill, minmax( 88px, 1fr ) )
</style>
